module.exports = __webpack_public_path__ + "static/kran02_1024-f2ae5e6c2aa3b82f148c432063587372.jpg";